import type { CustomFlowbiteTheme } from 'flowbite-react';

export const radioTheme: CustomFlowbiteTheme['radio'] = {
  root: {
    base: 'h-4 w-4 border border-titan-night-300 focus:ring-2 focus:ring-titan-folly-500 text-titan-folly-600',
  },
};
